import { render, staticRenderFns } from "./BookingTermsAndConditionsModalNoAction.vue?vue&type=template&id=3db044b2&scoped=true"
import script from "./BookingTermsAndConditionsModalNoAction.vue?vue&type=script&lang=js"
export * from "./BookingTermsAndConditionsModalNoAction.vue?vue&type=script&lang=js"
import style0 from "./BookingTermsAndConditionsModalNoAction.vue?vue&type=style&index=0&id=3db044b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db044b2",
  null
  
)

export default component.exports